const BACKEND_BASE_URL =
  String(
    process.env.REACT_APP_BACKEND_BASE_URL ||
    ''
  )
    .trim()
    .replace(
      /\/+$/,
      ''
    );


function buildApiUrl(
  path
) {
  return (
    `${BACKEND_BASE_URL}${path}`
  );
}


async function parseResponse(
  response
) {
  let data =
    null;

  try {
    data =
      await response.json();
  } catch {
    data =
      null;
  }

  if (
    !response.ok
  ) {
    throw new Error(
      data?.message ||
      `HTTP ${response.status}`
    );
  }

  return data;
}


function getResponseData(
  response
) {
  return (
    response?.data ||
    response ||
    {}
  );
}


export async function requestFindAccount(
  email,
  language,
) {
  const response =
    await fetch(
      buildApiUrl(
        '/api/findaccount'
      ),
      {
        method:
          'POST',

        credentials:
          'include',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            email,

            locale:
              language,
          }),
      },
    );

  const responseBody =
    await parseResponse(
      response
    );

  const data =
    getResponseData(
      responseBody
    );

  return {
    matched:
      data.matched === true,

    sent:
      data.sent === true,
  };
}


export async function requestPasswordReset({
  loginId,
  email,
  locale,
}) {
  const response =
    await fetch(
      buildApiUrl(
        '/api/passwordreset'
      ),
      {
        method:
          'POST',

        credentials:
          'include',

        headers: {
          'Content-Type':
            'application/json',
        },

        body:
          JSON.stringify({
            loginId,
            email,
            locale,
          }),
      },
    );

  const responseBody =
    await parseResponse(
      response
    );

  const data =
    getResponseData(
      responseBody
    );

  return {
    matched:
      data.matched === true,

    sent:
      data.sent === true,
  };
}
